import React, { useState, useMemo } from 'react';
import { Search, ChevronDown, ChevronRight } from 'lucide-react';
import './HelpPage.scss';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQCategory {
  title: string;
  items: FAQItem[];
}

const faqData: FAQCategory[] = [
  {
    title: 'Skelbimų paieška',
    items: [
      {
        question: 'Greita skelbimų paieška',
        answer: 'Pagrindiniame CVgidas.lt puslapyje įveskite raktažodį (pareigas, įmonę ar sritį) ir, jei norite, miestą – tada spauskite ieškoti. Sistema atidarys skelbimų sąrašą su jau pritaikytais filtrais.\n\nGreita paieška tinka, kai žinote, ko ieškote. Jei norite rinktis kelias sritis, atlyginimą ar darbo tipą, naudokite detalią paiešką.',
      },
      {
        question: 'Detali skelbimų paieška',
        answer: 'Atidarykite Darbo skelbimai arba detalią paiešką pradžios puslapyje. Ten galite derinti kelis filtrus: darbo vietą, sritį, pareigybes, įmonę, darbo tipą, darbo laiką ir atlyginimą.\n\nKairėje matysite, kiek skelbimų atitinka pasirinkimą. Filtrus galima nuimti po vieną arba išvalyti visus ir pradėti iš naujo.',
      },
      {
        question: 'Skelbimų paieška pagal sritį',
        answer: 'Filtre „Darbo sritys“ pasirinkite vieną ar kelias sritis (pavyzdžiui, IT, finansai, administravimas). Galite eiti giliau – nuo srities prie tipo ir konkrečios pareigybės.\n\nSąrašas atsinaujina iš karto. Jei sritis parinkčių tinklelyje neryški, šiuo metu nėra skelbimų, atitinkančių jau pasirinktus kitus filtrus.',
      },
      {
        question: 'Skelbimų paieška pagal vietą',
        answer: 'Filtre „Darbo vietos“ pažymėkite miestus arba rinkitės nuotolinį darbą, visą Lietuvą ar užsienį. Galima rinktis kelis miestus vienu metu.\n\nPaieškos laukelyje „Įveskite miestą“ greitai rasite mažesnę vietovę. Vilnius, Kaunas, Klaipėda, Šiauliai ir Panevėžys rodomi sąrašo viršuje.',
      },
      {
        question: 'Skelbimų paieška pagal pareigybes',
        answer: 'Atidarę „Darbo sritys“, pasirinkite sritį ir, jei reikia, tipą – tada pamatysite pareigybių sąrašą. Pažymėkite tas, kurios jums tinka (pvz., buhalteris, programuotojas).\n\nPareigybės sujungtos su sinonimais, todėl „buhalteris“ ras ir panašius skelbimus, jei jie priskirti tai pačiai grupei.',
      },
      {
        question: 'Skelbimų paieška pagal įmonę',
        answer: 'Filtre „Įmonės“ pirmiausia galite pasirinkti veiklos sritį, tada – konkrečią įmonę. Įmonės paieškos laukelyje rašykite pavadinimo dalį.\n\nŠalia pavadinimo matote, kiek ta įmonė šiuo metu turi paskelbtų skelbimų.',
      },
      {
        question: 'Paieškos tikslinimas',
        answer: 'Pridėkite daugiau filtrų – vietą, sritį, darbo tipą, laiką ar minimalų atlyginimą. Kiekvienas pasirinkimas siaurina sąrašą.\n\nJei rezultatų per mažai, nuimkite vieną filtrą (pavyzdžiui, atlyginimą) arba palikite tik sritį ir miestą. Viršuje visada matote, kiek skelbimų rasta.',
      },
      {
        question: 'Kaip išsaugoti skelbimus?',
        answer: 'Prisijunkite kaip ieškantis darbo ir skelbimo kortelėje arba skelbimo lange spauskite žymės piktogramą. Skelbimas atsiras skiltyje Pažymėti skelbimai.\n\nIšsaugoti gali tik registruoti ieškantys darbo. Jei piktograma nerodoma, įsitikinkite, kad esate prisijungę prie darbuotojo paskyros.',
      },
      {
        question: 'Kaip išsaugoti skelbimų paiešką?',
        answer: 'Nustatykite filtrus skiltyje Darbo skelbimai, tada išsaugokite paiešką. Arba eikite į Išsaugotos paieškos ir spauskite „Nauja paieška“ – suteikite pavadinimą ir pasirinkite tuos pačius filtrus (vietą, sritis, įmones, atlyginimą).\n\nIšsaugota paieška lieka paskyroje, kad vėliau ją paleistumėte vienu paspaudimu.',
      },
      {
        question: 'Kaip paleisti išsaugotą skelbimų paiešką?',
        answer: 'Atidarykite Išsaugotos paieškos. Sąraše raskite norimą paiešką ir ją atidarykite – būsite nukreipti į skelbimų sąrašą su tais pačiais filtrais.\n\nJei paiešką naudojate dažnai, suteikite jai aiškų pavadinimą, pvz. „Programuotojas Vilniuje“.',
      },
      {
        question: 'Kaip keisti išsaugotos paieškos nustatymus?',
        answer: 'Skiltyje Išsaugotos paieškos atidarykite paiešką redagavimui. Pakeiskite pavadinimą ar filtrus (miestus, sritis, įmones, atlyginimą) ir spauskite „Atnaujinti“.\n\nPakeitimai įsigalioja iš karto – kitą kartą paleidus paiešką matysite jau atnaujintus rezultatus.',
      },
      {
        question: 'Kaip esamos paieškos pagrindu sukurti naują paiešką?',
        answer: 'Atidarykite esamą paiešką, pakeiskite tai, kas skiriasi (pavyzdžiui, pridėkite Kauną arba kitą sritį), tada išsaugokite kaip naują paiešką kitu pavadinimu.\n\nSenoji paieška lieka nepakitusi. Taip patogu turėti kelis variantus – miestui, sričiai ar atlyginimui.',
      },
      {
        question: 'Kaip ištrinti išsaugotą skelbimų paiešką',
        answer: 'Skiltyje Išsaugotos paieškos pažymėkite nebereikalingą paiešką ir ją ištrinkite. Sistema paprašys patvirtinti, nes veiksmo atšaukti negalima.\n\nIštrynus paiešką, skelbimai portale niekur nedingsta – išnyksta tik jūsų išsaugotas filtrų rinkinys.',
      },
    ],
  },
  {
    title: 'Kandidatavimas pagal darbo skelbimus',
    items: [
      {
        question: 'Kaip kandidatuoti registruotam vartotojui?',
        answer: 'Atidarykite skelbimą ir skiltyje „Kandidatavimas“ pasirinkite CV (pagal nutylėjimą parenkamas publikuojamas CV). Jei norite, pridėkite motyvacinį laišką ir spauskite siųsti.\n\nPrieš kandidatuodami turėkite bent vieną CV skiltyje Mano CV. Darbdavys matys tą CV, kurį pateikėte su paraiška.',
      },
      {
        question: 'Kaip kandidatuoti neregistruotam vartotojui?',
        answer: 'Kandidatuoti galima tik prisijungus. Skelbimo lange pamatysite raginimą prisijungti arba susikurti paskyrą – po to būsite grąžinti į tą patį skelbimą.\n\nRegistracija nemokama. Susikūrę paskyrą pirmiausia užpildykite CV, tada galėsite siųsti paraiškas.',
      },
      {
        question: 'Kaip kandidatuoti į kelias pozicijas iš karto?',
        answer: 'Kiekvieną skelbimą reikia atidaryti atskirai ir pateikti paraišką. Masinio kandidatavimo į kelis skelbimus vienu mygtuku nėra – taip darbdavys gauna jūsų sąmoningą pasirinkimą.\n\nJei kandidatuojate į kelias tos pačios įmonės pozicijas, galite naudoti tą patį CV, o motyvacinį laišką pritaikyti kiekvienai.',
      },
      {
        question: 'Kaip galima matyti skelbimus, į kuriuos jau kandidatuota?',
        answer: 'Visi jūsų pateikti kandidatavimai yra skiltyje Kandidatavimas. Ten matote skelbimą, datą ir būseną.\n\nJei skelbimas vis dar galioja, galite jį vėl atidaryti. Į tą patį skelbimą antrą kartą kandidatuoti paprastai negalima.',
      },
    ],
  },
  {
    title: 'Kaip įvesti CV?',
    items: [
      {
        question: 'Kaip sukurti naują CV?',
        answer: 'Prisijunkite ir eikite į Mano CV arba spauskite „Įkelti CV“ viršuje. Užpildykite asmeninius duomenis, patirtį, išsilavinimą, kalbas ir pageidaujamą darbą, tada išsaugokite.\n\nCV galite turėti kelis – pavyzdžiui, vieną IT sričiai, kitą administravimui. Publikuojamą CV pažymėkite žvaigždute arba pasirinkimu „Publikuojama“.',
      },
      {
        question: 'Kaip redaguoti esamą CV?',
        answer: 'Skiltyje Mano CV atidarykite CV redagavimui. Pakeiskite reikiamus blokus ir išsaugokite. Darbdaviai, kuriems jau siuntėte paraišką, mato tą versiją, kurią pateikėte tuo metu.\n\nNaujos paraiškos naudos atnaujintą CV, jei jį vėl pasirinksite kandidatuodami.',
      },
      {
        question: 'Kaip pasirinkti, kuris CV rodomas darbdaviams?',
        answer: 'Mano CV sąraše pažymėkite vieną CV kaip publikuojamą. Jis automatiškai parenkamas kandidatuojant ir matomas kandidatų paieškoje, jei CV paskelbtas.\n\nVienu metu publikuojamas gali būti tik vienas CV. Kitų neištrinate – jie lieka juodraščiais ar atsarginiais variantais.',
      },
      {
        question: 'Kaip ištrinti CV?',
        answer: 'Mano CV pažymėkite CV ir jį ištrinkite. Sistema paprašys patvirtinti. Ištrynimas galutinis – atkurti CV negalėsite.\n\nJei CV jau siuntėte su paraiška, darbdavys vis tiek mato tada pateiktą kopiją. Naujų paraiškų su tuo CV pateikti nebegalėsite.',
      },
    ],
  },
  {
    title: 'Motyvaciniai laiškai',
    items: [
      {
        question: 'Kaip sukurti ir išsaugoti motyvacinį laišką?',
        answer: 'Eikite į Mano CV ir atidarykite skirtuką motyvaciniams laiškams. Spauskite naują laišką, įrašykite pavadinimą ir tekstą, tada išsaugokite.\n\nVieną laišką galite pažymėti kaip pagrindinį – jis bus siūlomas pirmas, kai kandidatuosite.',
      },
      {
        question: 'Kaip redaguoti motyvacinį laišką?',
        answer: 'Mano CV motyvacinių laiškų sąraše atidarykite laišką, pataisykite tekstą ar pavadinimą ir išsaugokite.\n\nJau išsiųstos paraiškos lieka su senu tekstu. Naujose paraiškose bus naudojama atnaujinta versija.',
      },
      {
        question: 'Kaip sukurti naują motyvacinį laišką jau esančio motyvacinio laiško pagrindu?',
        answer: 'Atidarykite esamą laišką, nukopijuokite tekstą, tada sukurkite naują laišką kitu pavadinimu ir įklijuokite turinį. Pritaikykite jį kitai įmonei ar pozicijai ir išsaugokite.\n\nTaip patogu turėti bendrą šabloną ir kelis pritaikytus variantus.',
      },
      {
        question: 'Kaip pašalinti motyvacinį laišką?',
        answer: 'Mano CV pažymėkite laišką ir jį ištrinkite. Galite trinti ir kelis iš karto. Veiksmą reikės patvirtinti.\n\nIštrynimas paraiškų istorijos neištrina – darbdavys vis tiek mato laišką, kurį siuntėte kartu su kandidatavimu.',
      },
    ],
  },
  {
    title: 'Kreipimosi laiškai',
    items: [
      {
        question: 'Kaip sukurti ir išsaugoti kreipimosi laišką?',
        answer: 'Kreipimosi (atsakymo) laiškai skirti darbdaviams – kvietimams pokalbiui. Prisijunkite darbdavio paskyra ir eikite į Atsakymų laiškai. Spauskite naują laišką, įrašykite pavadinimą bei tekstą ir išsaugokite.\n\nIšsaugotą laišką galėsite pasirinkti kviesdami kandidatą pokalbiui, kad kiekvieną kartą nerašytumėte iš naujo.',
      },
      {
        question: 'Kaip redaguoti kreipimosi laišką?',
        answer: 'Skiltyje Atsakymų laiškai atidarykite laišką, pataisykite tekstą ir išsaugokite.\n\nJau išsiųsti kvietimai nesikeičia. Nauji kvietimai naudos atnaujintą šabloną.',
      },
      {
        question: 'Kaip sukurti naują kreipimosi laišką jau esančio kreipimosi laiško pagrindu?',
        answer: 'Atidarykite esamą laišką, nukopijuokite tekstą ir sukurkite naują šabloną kitu pavadinimu (pvz., „Kvietimas į biurą“ ir „Nuotolinis pokalbis“).\n\nTaip greitai paruošite kelis variantus skirtingoms atrankoms.',
      },
      {
        question: 'Kaip pašalinti kreipimosi laišką?',
        answer: 'Atsakymų laiškų sąraše pažymėkite šabloną ir jį ištrinkite. Galite trinti kelis iš karto. Reikės patvirtinimo.\n\nIštrynus šabloną, jau išsiųsti kvietimai kandidatams lieka matomi pokalbių istorijoje.',
      },
    ],
  },
  {
    title: 'Skelbimų tvarkymas pagal sukurtas taisykles',
    items: [
      {
        question: 'Taisyklių esmė ir jų teikiami privalumai',
        answer: 'CVgidas.lt nenaudoja atskirų automatinių „taisyklių“. Tą patį darbą atlieka išsaugotos paieškos ir prenumeratos: nustatote kriterijus vieną kartą, o nauji atitinkantys skelbimai ateina el. paštu arba juos paleidžiate iš paskyros.\n\nTai paprasčiau – keičiate filtrus, o ne programines taisykles.',
      },
      {
        question: 'Taisyklių tipai pagal atliekamą funkciją',
        answer: 'Yra du būdai gauti tik jums tinkančius skelbimus. Išsaugota paieška – kai patys paleidžiate filtrus skiltyje Išsaugotos paieškos. Prenumerata – kai nauji skelbimai siunčiami el. paštu nedelsiant arba kartą per savaitę.\n\nAbu būdus galite naudoti kartu: paiešką – kasdieniams peržiūroms, prenumeratą – priminimams.',
      },
      {
        question: 'Kaip sukurti naują taisyklę?',
        answer: 'Sukurkite prenumeratą skiltyje Prenumeratos: įveskite pavadinimą, būtinai pasirinkite siuntimo dažnį ir filtrus (vietą, sritis, atlyginimą). Arba išsaugokite paiešką skiltyje Išsaugotos paieškos.\n\nAbiem atvejais kriterijai veikia kaip taisyklė – rodomi ar siunčiami tik atitinkantys skelbimai.',
      },
      {
        question: 'Kaip keisti taisyklės kriterijus?',
        answer: 'Atidarykite prenumeratą arba išsaugotą paiešką redagavimui, pakeiskite filtrus ar dažnį ir išsaugokite.\n\nNuo kito siuntimo ar kito paieškos paleidimo galios jau nauji kriterijai.',
      },
      {
        question: 'Kaip sukurti naują taisyklę jau esančios taisyklės pagrindu?',
        answer: 'Atidarykite esamą prenumeratą ar paiešką, pakeiskite tai, kas skiriasi, ir išsaugokite kaip naują įrašą kitu pavadinimu.\n\nSenoji prenumerata ar paieška lieka. Taip patogu turėti atskirus variantus Vilniui ir Kaunui.',
      },
      {
        question: 'Kaip sustabdyti taisyklės veikimą?',
        answer: 'Prenumeratų sąraše išjunkite prenumeratą – laiškai nebebus siunčiami, bet nustatymai išliks. Kai vėl prireiks, įjungsite tą pačią prenumeratą.\n\nIšsaugota paieška laiškų nesiunčia, todėl jos „stabdyti“ nereikia – tiesiog jos nepaleiskite.',
      },
      {
        question: 'Kaip ištrinti taisyklę?',
        answer: 'Prenumeratose arba Išsaugotose paieškose pažymėkite įrašą ir jį ištrinkite. Reikės patvirtinimo, veiksmo atšaukti negalima.\n\nIštrynus prenumeratą laiškai nebeateis. Skelbimai portale lieka – dingsta tik jūsų filtrų rinkinys.',
      },
    ],
  },
  {
    title: 'Skelbimų kategorijų tvarkymas',
    items: [
      {
        question: 'Kaip sukurti naują skelbimų kategoriją?',
        answer: 'Ieškantiems darbo atskirų kategorijų kurti nereikia – skelbimus filtruojate pagal darbo sritį paieškoje, o pažymėtus matote skiltyje Pažymėti skelbimai.\n\nDarbdaviai savo skelbimus gali dėlioti į aplankus skiltyje Mano skelbimai: sukurkite aplanką ir priskirkite jam skelbimus.',
      },
      {
        question: 'Kaip keisti skelbimų kategorijos nustatymus?',
        answer: 'Jei esate darbdavys, atidarykite aplanką Mano skelbimuose ir pakeiskite jo pavadinimą. Skelbimus galima perkelti į kitą aplanką arba palikti be aplanko.\n\nIeškantiems darbo „kategorija“ yra paieškos filtras – pakeiskite darbo sritį ar išsaugotą paiešką.',
      },
      {
        question: 'Kaip sukurti naują skelbimų kategoriją jau esančios kategorijos pagrindu?',
        answer: 'Darbdaviams: sukurkite naują aplanką ir perkelkite į jį dalį skelbimų iš seno aplanko. Ieškantiems darbo: nukopijuokite išsaugotos paieškos filtrus ir išsaugokite kitu pavadinimu.\n\nTaip atskirsite, pvz., IT ir administravimo skelbimus.',
      },
      {
        question: 'Kaip ištrinti skelbimų kategoriją?',
        answer: 'Darbdavys aplanką ištrina Mano skelbimuose. Skelbimai neištrinami – jie lieka sąraše be to aplanko.\n\nIeškantis darbo ištrina tik išsaugotą paiešką ar prenumeratą, ne pačius skelbimus.',
      },
    ],
  },
  {
    title: 'Auksinė narystė',
    items: [
      {
        question: 'Kokie yra auksinės narystės privalumai?',
        answer: 'Atskiros „auksinės narystės“ CVgidas.lt nėra. Ieškantiems darbo visos pagrindinės funkcijos – CV, paieška, kandidatavimas, prenumeratos ir pažymėti skelbimai – prieinamos paskyroje.\n\nPapildomai skiltyje Paslaugos galite iškelti CV, kad jis būtų matomesnis darbdavių paieškoje nustatytą laiką.',
      },
      {
        question: 'Kaip įsigyti auksinę narystę?',
        answer: 'Narystės plano pirkti nereikia. Jei norite, kad CV būtų rodomas aukščiau, eikite į Paslaugos, pasirinkite CV ir iškėlimo laikotarpį, tada apmokėkite.\n\nDarbdaviai skelbimų ir kandidatų paieškos paslaugas randa savo Paslaugų skiltyje.',
      },
      {
        question: 'Kaip atsisakyti auksinės narystės?',
        answer: 'Kadangi atskiros narystės nėra, atsisakyti nėra ko. Jei pirkote CV iškėlimą, jis galioja iki nurodytos datos ir pats pasibaigia.\n\nPrenumeratas ir laiškus visada galite išjungti ar ištrinti savo paskyroje.',
      },
    ],
  },
  {
    title: 'Skelbimų tvarkymas asmeninėje paskyroje',
    items: [
      {
        question: 'Gautų skelbimų aplankas',
        answer: 'Nauji skelbimai, atitinkantys prenumeratą, ateina el. paštu. Pačiame portale visus skelbimus naršote skiltyje Darbo skelbimai.\n\nKvietimus pokalbiui (kai darbdavys parašo jums) rasite skiltyje Pasiūlymai.',
      },
      {
        question: 'Atsakytų skelbimų aplankas',
        answer: 'Skelbimai, į kuriuos jau kandidavote, yra skiltyje Kandidatavimas. Ten matote datą ir skelbimo pavadinimą.\n\nAtsakymų iš darbdavio ieškokite Pasiūlymuose – ten atsiranda kvietimai pokalbiui.',
      },
      {
        question: 'Išsaugotų skelbimų aplankas',
        answer: 'Pažymėti skelbimai yra skiltyje Pažymėti skelbimai. Čia kaupiate pozicijas, prie kurių norite grįžti vėliau.\n\nŽymę galima nuimti – skelbimas dingsta tik iš šio sąrašo, ne iš portalo.',
      },
      {
        question: 'Ištrintų skelbimų aplankas',
        answer: 'Atskiro „šiukšliadėžės“ aplanko nėra. Jei nuėmėte žymę arba ištrynėte prenumeratą, skelbimas portale vis tiek lieka, kol galioja.\n\nIštrintos prenumeratos ir paieškos nebeatkuriamos – jei prireiks, sukurkite jas iš naujo.',
      },
      {
        question: 'Kaip perkelti skelbimus iš vieno aplanko į kitą?',
        answer: 'Ieškantiems darbo skelbimai priklauso trims sąrašams: pažymėti, kandidatuoti ir prenumeratos laiškai. „Perkelti“ reiškia pažymėti skelbimą, kandidatuoti į jį arba palikti tik prenumeratoje.\n\nDarbdaviai skelbimus perkelia tarp aplankų skiltyje Mano skelbimai.',
      },
      {
        question: 'Kaip persijusti skelbimus?',
        answer: 'Skelbimo lange galite nukopijuoti adresą ir nusiųsti kolegai. Atskiro persiuntimo mygtuko ieškantiems darbo nėra.\n\nDarbdavys kandidatą gali pakviesti pokalbiui iš kandidatų peržiūros – tam naudojami atsakymų laiškai.',
      },
      {
        question: 'Kaip ištrinti skelbimus?',
        answer: 'Savo pažymėtą skelbimą pašalinate nuimdami žymę skiltyje Pažymėti skelbimai. Portalo skelbimo taip neištrinsite – jį valdo darbdavys.\n\nDarbdavys savo skelbimą gali uždaryti ar ištrinti skiltyje Mano skelbimai.',
      },
    ],
  },
  {
    title: 'Skelbimų prenumerata',
    items: [
      {
        question: 'Kaip sukurti skelbimų prenumeratą?',
        answer: 'Eikite į Prenumeratos ir spauskite „Nauja prenumerata“. Įveskite pavadinimą, būtinai pasirinkite siuntimo dažnį (nedelsiant arba kartą per savaitę) ir filtrus – vietą, sritis, įmones, darbo tipą, atlyginimą.\n\nBe dažnio prenumeratos išsaugoti negalima. Laiškai ateis nurodytu el. paštu, kai atsiras atitinkančių skelbimų.',
      },
      {
        question: 'Kaip keisti skelbimų prenumeratos nustatymus?',
        answer: 'Prenumeratų sąraše atidarykite prenumeratą redagavimui. Pakeiskite pavadinimą, dažnį ar filtrus ir spauskite „Atnaujinti“.\n\nNuo kito siuntimo galios nauji kriterijai.',
      },
      {
        question: 'Kaip sukurti naują skelbimų prenumeratą jau esančios prenumeratos pagrindu?',
        answer: 'Atidarykite esamą prenumeratą, pakeiskite skirtingus filtrus (pvz., kitą miestą) ir išsaugokite kaip naują prenumeratą kitu pavadinimu.\n\nSenoji prenumerata lieka. Taip galite gauti atskirus laiškus skirtingoms sritims.',
      },
      {
        question: 'Kaip sustabdyti skelbimų prenumeratą?',
        answer: 'Prenumeratų sąraše išjunkite prenumeratą. Laiškai nebebus siunčiami, o filtrai išliks – vėliau galėsite vėl įjungti.\n\nJei prenumeratos nebereikia visai, ją ištrinkite.',
      },
      {
        question: 'Kaip ištrinti skelbimų prenumeratą?',
        answer: 'Pažymėkite prenumeratą ir ją ištrinkite. Sistema paprašys patvirtinti – veiksmo atšaukti negalima.\n\nPo ištrynimo nauji skelbimai el. paštu nebeateis. Skelbimai portale lieka matomi paieškoje.',
      },
    ],
  },
];

const HelpPage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedCategories, setExpandedCategories] = useState<string[]>([faqData[0]?.title || '']);
  const [expandedQuestions, setExpandedQuestions] = useState<string[]>(['Greita skelbimų paieška']);
  const [showDropdown, setShowDropdown] = useState(false);

  // Search results for autocomplete
  const searchResults = useMemo(() => {
    if (!searchQuery.trim()) return [];
    
    const query = searchQuery.toLowerCase();
    const results: { category: string; question: string; answer: string }[] = [];
    
    faqData.forEach(category => {
      category.items.forEach(item => {
        if (item.question.toLowerCase().includes(query) || item.answer.toLowerCase().includes(query)) {
          results.push({
            category: category.title,
            question: item.question,
            answer: item.answer
          });
        }
      });
    });
    
    return results.slice(0, 5);
  }, [searchQuery]);

  const toggleCategory = (title: string) => {
    setExpandedCategories(prev => 
      prev.includes(title) 
        ? prev.filter(t => t !== title)
        : [...prev, title]
    );
  };

  const toggleQuestion = (question: string) => {
    setExpandedQuestions(prev => 
      prev.includes(question)
        ? prev.filter(q => q !== question)
        : [...prev, question]
    );
  };

  const handleSearch = () => {
    setShowDropdown(false);
    // Could scroll to first result or filter FAQ
  };

  const handleSelectResult = (result: { category: string; question: string }) => {
    setSearchQuery('');
    setShowDropdown(false);
    
    // Expand the category and question
    if (!expandedCategories.includes(result.category)) {
      setExpandedCategories(prev => [...prev, result.category]);
    }
    if (!expandedQuestions.includes(result.question)) {
      setExpandedQuestions(prev => [...prev, result.question]);
    }

    // Scroll to the question
    setTimeout(() => {
      const element = document.getElementById(`question-${result.question.replace(/\s+/g, '-')}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  const highlightText = (text: string, query: string) => {
    if (!query.trim()) return text;
    
    const regex = new RegExp(`(${query})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, i) => 
      regex.test(part) ? <strong key={i}>{part}</strong> : part
    );
  };

  return (
    <div className="help-page">
      {/* Hero Section */}
      <section className="help-hero">
        <div className="hero-content">
          <h1>Pagalba</h1>
          <div className="search-container">
            <div className="search-wrapper">
              <input
                type="text"
                placeholder="Įveskite paieškos žodį"
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  setShowDropdown(true);
                }}
                onFocus={() => setShowDropdown(true)}
                onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
              />
              <button className="search-btn" onClick={handleSearch}>
                <Search size={18} />
                IEŠKOTI
              </button>
              
              {/* Search Dropdown */}
              {showDropdown && searchResults.length > 0 && (
                <div className="search-dropdown">
                  {searchResults.map((result, index) => (
                    <div 
                      key={index} 
                      className="dropdown-item"
                      onClick={() => handleSelectResult(result)}
                    >
                      <div className="item-question">
                        {highlightText(result.question, searchQuery)}
                      </div>
                      <div className="item-preview">
                        {highlightText(result.answer.substring(0, 150) + '...', searchQuery)}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="faq-container">
          {faqData.map((category) => (
            <div key={category.title} className="faq-category">
              <button 
                className={`category-header ${expandedCategories.includes(category.title) ? 'expanded' : ''}`}
                onClick={() => toggleCategory(category.title)}
              >
                <h2>{category.title}</h2>
                <ChevronDown size={20} className="chevron" />
              </button>
              
              {expandedCategories.includes(category.title) && (
                <div className="category-content">
                  {category.items.map((item) => (
                    <div 
                      key={item.question} 
                      className="faq-item"
                      id={`question-${item.question.replace(/\s+/g, '-')}`}
                    >
                      <button 
                        className={`question-header ${expandedQuestions.includes(item.question) ? 'expanded' : ''}`}
                        onClick={() => toggleQuestion(item.question)}
                      >
                        <ChevronRight size={16} className="chevron" />
                        <span>{item.question}</span>
                      </button>
                      
                      {expandedQuestions.includes(item.question) && (
                        <div className="answer">
                          {item.answer.split('\n\n').map((paragraph, i) => (
                            <p key={i}>{paragraph}</p>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default HelpPage;




